import { preferences } from './preferences'
import { router, navigate } from './router'

export function isTextEntryTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false
  if (target.isContentEditable) return true
  return (
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLSelectElement
  )
}

export function initializeShortcuts(): void {
  window.addEventListener('keydown', (event) => {
    if (
      !preferences.shortcuts ||
      event.isComposing ||
      isTextEntryTarget(event.target)
    )
      return
    if (event.ctrlKey || event.metaKey || event.altKey) return
    const world = router.current.worldId
    const village = router.current.villageId
    if (!world) return
    const key = event.key.toLowerCase()
    const path =
      key === 'm'
        ? `/world/${world}/map`
        : key === 'r'
          ? `/world/${world}/reports`
          : key === 'd' && village
            ? `/world/${world}/village/${village}/dashboard`
            : key === 'a' && village
              ? `/world/${world}/village/${village}/army`
              : null
    if (path) {
      event.preventDefault()
      navigate(path)
    }
  })
}
